module.exports = __webpack_public_path__ + "img/bpm.c9f994f8.svg";